export interface CreateUserModel {
    clientId: number;
    firstName: string;
    lastName: string;
    emailOrPhoneNumber: string;
    securityCode: number;
    preferredLanguageId: number;
    receivesNotifications: boolean;
    acceptedPrivacyPolicy: boolean;
}
